module.exports = __webpack_public_path__ + "static/village_title_logo@2x-8a69d27c7cf0951256e6c908c001a7ce.png";